import React from 'react';
import { InputLabelProps, SxProps, TextField } from '@mui/material';
import { Colors } from '../../../utils/theme';

interface IProps {
  id: string;
  label?: string;
  value: string | number | null;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: 'text' | 'number' | 'password';
  disabled?: boolean;
  placeholder?: string;
  errorMsg?: string | null;
  isEditable?: boolean;
  additionalStyle?: SxProps;
  multiline?: boolean;
  rows?: number | string;
  onKeyPress?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  required?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  inputLabelProps?: Partial<InputLabelProps>;
  withoutBackground?: boolean;
  isWhite?: boolean;
  boldText?: boolean;
}

const InputComponent: React.FunctionComponent<IProps> = ({
  id,
  label,
  value,
  onChange,
  type = 'text',
  disabled = false,
  placeholder,
  errorMsg,
  isEditable = true,
  additionalStyle,
  multiline = false,
  rows,
  onKeyPress,
  required,
  startAdornment,
  endAdornment,
  withoutBackground = false,
  inputLabelProps,
  boldText = false,
  isWhite = false
}) => {
  const defaultLabelProps: Partial<InputLabelProps> = {
    shrink: true,
    sx: {
      lineHeight: '22px',
      top: '-14px',
      left: '15px',
      color:
        errorMsg !== undefined && errorMsg !== null
          ? Colors.red
          : isEditable
          ? Colors.main
          : Colors.gray
    }
  };

  const getBackGround = () => {
    if (isWhite) {
      return 'white';
    } else if (withoutBackground) {
      return 'none';
    } else {
      return Colors.input_background;
    }
  };

  return (
    <TextField
      variant="standard"
      id={id}
      data-testid={id}
      name={id}
      label={label}
      type={type}
      fullWidth
      multiline={multiline}
      required={required ?? false}
      value={value}
      rows={rows}
      onKeyPress={onKeyPress}
      onChange={onChange}
      disabled={disabled}
      {...(placeholder && { placeholder })}
      {...(errorMsg !== undefined && {
        error: errorMsg !== null,
        helperText: errorMsg ?? '',
        required: required ?? true
      })}
      sx={{
        background: getBackGround(),
        borderRadius: '9px',
        height: multiline ? 'auto' : '36px',
        pl: startAdornment ? '5px' : '12px',
        pr: '15px',
        ...additionalStyle
      }}
      InputProps={{
        disableUnderline: true,
        sx: {
          margin: '0 !important',
          fontWeight: boldText ? 'bold' : 'normal'
        },
        startAdornment: startAdornment,
        endAdornment: endAdornment
      }}
      inputProps={{
        sx: {
          height: multiline ? 'auto' : '36px',
          paddingY: 0,
          color: isEditable
            ? errorMsg !== undefined && errorMsg !== null
              ? Colors.red
              : Colors.main
            : Colors.dark_gray
        },
        'data-testid': `${id}-value`
      }}
      InputLabelProps={inputLabelProps ?? defaultLabelProps}
    />
  );
};

export default InputComponent;
